// extracted by mini-css-extract-plugin
module.exports = {"chart":"BigFiveDomainChart_chart__eHTiO"};